// components/PDFViewerModal.js
import * as Dialog from '@radix-ui/react-dialog';
import '../styles/PDFViewerModal.css';

const PDFViewerModal = ({ isOpen, onClose, pdfUrl }) => {
  return (
    <Dialog.Root open={isOpen} onOpenChange={(open) => { if (!open) onClose(); }}>
      <Dialog.Portal>
        <Dialog.Overlay className="pdfviewer-overlay" />
        <Dialog.Content className="pdfviewer-content">
          <Dialog.Title className="pdfviewer-title">詳細PDF</Dialog.Title>
          <div className="pdfviewer-close-area">
            <button onClick={onClose} className="pdfviewer-close-button">
              閉じる
            </button>
          </div>
          {pdfUrl ? (
            <iframe
              src={pdfUrl}
              className="pdfviewer-iframe"
              title="PDF Viewer"
            />
          ) : (
            <p>PDFが選択されていません。</p>
          )}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default PDFViewerModal;
